import { ADDITIONAL_ELECTRIC_TREND_TYPE } from "../../constants/trendGraph/additionalElectricTrend";

export const formatCustomGraphDataForCSV = (graphData, customChartSettings) => {
  if(!graphData) return [];
  const graphDataWithChannelName = [];
  graphData?.forEach((data) => {
    const obj = {};
    obj.dateTime = data.dateTime;
    customChartSettings?.forEach((e) => {
      const channelNameWithChannelNumber = `${e.key.replace(/"/g, "")}_${e.name}`
      obj[channelNameWithChannelNumber] = data[e.key];
    });
    graphDataWithChannelName.push(obj);
  });
  return graphDataWithChannelName;
}

export const formatAdditionalElectricDataForCSV = (graphData, graphConfig) => {
  if(!graphData) return [];
  if(!graphConfig) return [];
  const nameListMap = new Map();
  graphConfig.commonNames.forEach((commonName, i) => {
    nameListMap.set(commonName, graphConfig.chName[i]);
  })
  const graphDataWithName = graphData.map((data) => {
    const dataList = Object.entries(data).map(([key, value]) => {
      const channelName = nameListMap.get(key);
      return [channelName ?? key, value];
    })
    return Object.fromEntries(dataList);
  })
  return graphDataWithName;
}

export const formatGraphDataForCSV = (graphData, isCustom, customChartSettings, selectedChart, graphConfig) => {
  if(!graphData) return [];
  if(isCustom) {
    return formatCustomGraphDataForCSV(graphData, customChartSettings);
  }
  if(Object.values(ADDITIONAL_ELECTRIC_TREND_TYPE).includes(selectedChart)) {
    return formatAdditionalElectricDataForCSV(graphData, graphConfig)
  }
  return graphData;
};